import { useEffect, useState, useCallback } from "react";
import Header from "../../Components/Header";
import axios from "axios";
import { LE_CHECKIN_API, LE_SEARCH_GUESTS_API } from "../../Constant/api";
import { useToast } from "../../Components/Toast";
import { Call, Clock, Sms, TableLamp, TickCircle, User } from "iconsax-react";
import Modal from "../../Components/Modal";
import { useLocation } from "react-router-dom";

const LESelfCheckIn = () => {
  const [search, setSearch] = useState("");
  const [guestToCheckIn, setGuestToCheckIn] = useState(null);
  const [guestList, setGuestList] = useState(null);
  const [showCheckInModal, setShowCheckInModal] = useState(false);

  const { toast } = useToast();

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const eventId = params.get("event_id");

  const searchGuest = useCallback(async (searchTerm) => {
    axios
      .get(LE_SEARCH_GUESTS_API, {
        params: {
          event_id: eventId,
          search: searchTerm,
        },
      })
      .then((response) => {
        setGuestList(response.data.data);
      })
      .catch((error) => {
        toast(
          error.response?.data?.message || "Failed to fetch guest list",
          "error",
        );
        console.error("Error fetching guest list:", error);
      });
  }, [eventId, toast]);

  const handleCloseModal = () => {
    setShowCheckInModal(false);
    setGuestToCheckIn(null);
  };

  const handleCheckInGuest = (guest_id) => {
    axios
      .put(LE_CHECKIN_API, { id: guest_id })
      .then((response) => {
        toast("Checked in successfully", "success");
        setSearch("");
        handleCloseModal();
      })
      .catch((error) => {
        toast(
          error.response?.data?.message || "Failed to check in guest",
          "error",
        );
        console.error("Error checking in guest:", error);
      });
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      if (search.trim() !== "") {
        searchGuest(search.trim());
      } else {
        setGuestList(null);
      }
    }, 1000);
    return () => clearTimeout(handler);
  }, [search, searchGuest]);

  return (
    <div className="flex flex-col w-full min-h-screen">
      <Header noSidebar={true} doNotLink={true} />

      {showCheckInModal && (
        <Modal
          title="Check In Confirmation"
          toggleModal={handleCloseModal}
          submitLabel="Check In"
          handleSubmit={() => handleCheckInGuest(guestToCheckIn.id)}
        >
          <div className="grid grid-cols-1 md:grid-cols-2 w-full gap-4">
            <div>
              <div className="flex items-center gap-2">
                <User size="16" variant="Bold" />
                <p>Guest Name:</p>
              </div>
              <h2 className="text-[20px]">
                {guestToCheckIn?.first_name} {guestToCheckIn?.last_name}
              </h2>
            </div>
            <div>
              <div className="flex items-center gap-2">
                <Sms size="16" variant="Bold" />
                <p>Email:</p>
              </div>
              <h2 className="text-[20px]">
                {guestToCheckIn?.email ?? "No email"}
              </h2>
            </div>
            <div>
              <div className="flex items-center gap-2">
                <Call size="16" variant="Bold" />
                <p>Phone No:</p>
              </div>
              <h2 className="text-[20px]">
                {guestToCheckIn?.contact ?? "No contact"}
              </h2>
            </div>
            <div>
              <div className="flex items-center gap-2">
                <TableLamp size="16" variant="Bold" />
                <p>Table:</p>
              </div>
              <h2 className="text-[20px] text-[#5C4BF5]">
                {guestToCheckIn?.table ?? "No table"}
              </h2>
            </div>
          </div>
        </Modal>
      )}

      <div className="flex w-full h-full items-center justify-center">
        <div className="relative flex w-full justify-center">
          <input
            type="text"
            placeholder="Enter your name or contact details to search"
            className="text-[16px] md:text-[32px] bg-transparent w-[90%] md:w-[50%] text-center border-b focus:outline-none"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          {guestList && guestList.length > 0 && (
            <div className="absolute flex flex-col w-[90%] md:w-[50%] p-4 rounded-lg bg-white top-14 border gap-4 z-10 max-h-[300px] overflow-y-scroll">
              {guestList.map((guest) => (
                <div
                  className="flex items-center w-full justify-between rounded-lg p-4 hover:bg-gray-100 cursor-pointer"
                  key={guest.id}
                  onClick={() => {
                    setGuestToCheckIn(guest);
                    setShowCheckInModal(true);
                  }}
                >
                  <div className="flex flex-col">
                    <p>
                      {guest.first_name} {guest.last_name}
                    </p>
                    <p className="text-gray-400">
                      {guest.email ? guest.email : "No email"}
                    </p>
                    <p className="text-gray-400">
                      {guest.contact ? guest.contact : "No contact"}
                    </p>
                  </div>
                  {guest.status ? (
                    <div className="flex w-fit rounded-md px-[8px] gap-[4px] items-center bg-[#F4FCF7] border border-[#E9F9EF] text-[#22C55E]">
                      <TickCircle size="16" variant="Bold" />
                      Checked
                    </div>
                  ) : (
                    <div className="flex w-fit rounded-md px-[8px] gap-[4px] items-center bg-[#FFFBF3] border border-[#FEF6E6] text-[#F0A009]">
                      <Clock size="16" variant="Bold" />
                      Pending
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default LESelfCheckIn;
